//#region Styles
import { TitleSection } from "components/styles";
import { 
    Container, 
    Content, 
    CampusCard } from "./styles";
//#endregion
//#region Icons
import HomeIcon from "icons/HomeIcon";
//#endregion

const CampusOptionList = ({
    campusList,
    onCampus
}) => {
    return (
        <Container>
            <TitleSection textAlign="center">Campus</TitleSection>
            <Content>
                {campusList.map(({ id, name }) => {
                    return (
                        <CampusCard 
                            key={id}
                            onClick={() => onCampus(id)}>
                            <span className="icon"><HomeIcon/></span>
                            <h5 className="text">{name}</h5>
                        </CampusCard>
                    );
                })}
            </Content>
        </Container>
    );
}

export default CampusOptionList;